export default {
    created() {
        document.addEventListener("scroll", this.handleScroll.bind(this));
    },
    beforeDestroy() {
        document.removeEventListener("scroll", this.handleScroll.bind(this));
    }
};
